import {
  IOffshoreReport,
  OFFSHORE_REPORT_STORE_ID,
  OffshoreFormConfig,
} from '@navstation-portal/reporting/data-model/offshore-report';
import { type } from '@ngrx/signals';
import { EntityId } from '@ngrx/signals/entities';
import { eventGroup } from '@ngrx/signals/events';

export type CreateReportOptions = {
  openAfterCreation: boolean;
  nextReportNumber: number;
};

export const offshoreReportEvents = eventGroup({
  source: OFFSHORE_REPORT_STORE_ID,
  events: {
    reset: type<void>(),
    fetchReport: type<EntityId>(),
    fetchReportSuccess: type<IOffshoreReport>(),
    fetchReportFailed: type<string>(),
    createReport: type<{ vesselId: string; nextReportNumber: number }>(),
    createReportSuccess: type<{
      vesselId: string;
      reportId: EntityId;
      report: IOffshoreReport;
    }>(),
    createReportFailed: type<Error>(),
    submitReport: type<EntityId>(),
    submitReportSuccess: type<{ reportId: EntityId; report: IOffshoreReport }>(),
    submitReportFailed: type<string>(),
    saveReport: type<EntityId>(),
    saveReportSuccess: type<{ reportId: EntityId; report: IOffshoreReport }>(),
    saveReportFailed: type<string>(),
    deleteReport: type<EntityId>(),
    deleteReportSuccess: type<EntityId>(),
    deleteReportFailed: type<string>(),
    setFormConfig: type<OffshoreFormConfig>(),
    clearForm: type<void>(),
    initialiseReportForm: type<EntityId>(),
  },
});
